<template>
<div class="chapter">
<div class="inner_page">
<div id="Dedication.html" xml:lang="en-US">
<div class="story">
<p class="pl-center">To Maisey, Caitlin and Jennie, who first inspired me with the idea for this story! Love, K.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?6c36a969